import script from "./TurnosPaciente.vue?vue&type=script&setup=true&lang=js"
export * from "./TurnosPaciente.vue?vue&type=script&setup=true&lang=js"

import "./TurnosPaciente.vue?vue&type=style&index=0&id=fb983efe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb983efe"]])

export default __exports__